import MUISwitch from '@mui/material/Switch';

type SwitchProps = React.ComponentProps<typeof MUISwitch> & {
  onChange?: (value: boolean) => void;
  value: boolean;
  ariaLabel?: string;
};

export const Switch = ({
  onChange,
  value,
  ...props
}: Readonly<SwitchProps>) => {
  return (
    <MUISwitch
      {...props}
      slotProps={{
        input: {
          'aria-label': props.ariaLabel,
        },
      }}
      onChange={(_, v: boolean) => onChange?.(v)}
      checked={value}
    />
  );
};
